import React from 'react';
import PropTypes from 'prop-types';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';
import { Button } from '@ann/web-components';
import {
  FilterBarContainer,
  FormWrapper,
  ActionsWrapper,
} from './DashboardFilterBar.styled';

/**
 * Renders global dashboard filters using RJSF (react-jsonschema-form).
 * Hidden when there are no filter definitions.
 */
const DashboardFilterBar = ({
  schema,
  uiSchema,
  formData,
  isDirty,
  onChange,
  onApply,
  onClear,
}) => {
  if (!schema) return null;

  return (
    <FilterBarContainer>
      <FormWrapper>
        <Form
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          validator={validator}
          onChange={onChange}
          liveValidate={false}
        />
      </FormWrapper>
      <ActionsWrapper>
        <Button
          type="primary"
          size="small"
          label="Apply"
          onClick={onApply}
          disabled={!isDirty}
        />
        <Button
          type="secondary"
          size="small"
          label="Clear"
          onClick={onClear}
        />
      </ActionsWrapper>
    </FilterBarContainer>
  );
};

DashboardFilterBar.propTypes = {
  schema: PropTypes.object,
  uiSchema: PropTypes.object,
  formData: PropTypes.object,
  isDirty: PropTypes.bool,
  onChange: PropTypes.func,
  onApply: PropTypes.func,
  onClear: PropTypes.func,
};

DashboardFilterBar.defaultProps = {
  schema: null,
  uiSchema: {},
  formData: {},
  isDirty: false,
  onChange: undefined,
  onApply: undefined,
  onClear: undefined,
};

export default DashboardFilterBar;
